import { Body, Button, Column, expandBorderRadii, paddingUtil, Pill, Row } from "@gadgetinc/widgets";
import { PencilIcon } from "@gadgetinc/widgets/src/icons/PencilIcon";
import { useStyletron } from "baseui";
import { observer } from "mobx-react-lite";
import React from "react";
import { useBillingSession } from "./BillingContext";

export const BillingContactCard = observer((props: { onEdit: () => void | Promise<void> }) => {
  const { onEdit } = props;
  const [_, $theme] = useStyletron();
  const billingSession = useBillingSession();

  return (
    <Column $gap={$theme.sizing.scale500} $align="space-between">
      <Row $align="space-between">
        <Body $style={{ fontWeight: 600 }}>Invoice sent to</Body>
        <Button
          $style={{ ...paddingUtil(0), color: $theme.colors.contentPrimary, textDecoration: "underline" }}
          kind="tertiary"
          onClick={onEdit}
          startEnhancer={<PencilIcon />}
        ></Button>
      </Row>
      <Column $style={{ alignSelf: "flex-start" }}>
        <Pill
          $style={{
            ...paddingUtil("0px", $theme.sizing.scale100, "0px", $theme.sizing.scale200),
            backgroundColor: $theme.colors.alpha200,
            ...expandBorderRadii($theme.borders.radius200),
          }}
        >
          <Body $style={{ color: $theme.colors.alpha500 }}>{billingSession.billingAccount.email}</Body>
        </Pill>
      </Column>
    </Column>
  );
});
